import React, { useState, useEffect } from 'react';
import {
  TextField, Button, Box, Typography, Dialog, DialogTitle, DialogContent, DialogActions
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import axios from 'axios';
import LayoutAdminHeader from '../components/LayoutAdminHeader';

const BASE_URL = process.env.REACT_APP_BASE_URL || '';

const HsnSac = () => {
  const [hsnSacs, setHsnSacs] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [selected, setSelected] = useState(null);
  const [open, setOpen] = useState(false);
  const [hsnSacName, setHsnSacName] = useState('');

  const fetchData = async () => {
    try {
      const token = localStorage.getItem("token");

const res = await axios.get(`${BASE_URL}/HsnSac/GetAllHsnSacs`, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});
      const data = res.data.data || [];
      setHsnSacs(data);
      setFiltered(data);
    } catch (err) {
      console.error('Failed to fetch HSN/SAC:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSearch = (e) => {
    const val = e.target.value.toLowerCase();
    setSearch(val);
    setFiltered(hsnSacs.filter(item => item.HsnSacName.toLowerCase().includes(val)));
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure to delete this HSN/SAC?')) return;
    try {
      const token = localStorage.getItem("token");

const res = await axios.delete(`${BASE_URL}/HsnSac/DeleteHsnSac/${id}`, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});
      fetchData();
    } catch (err) {
      alert('Delete failed');
    }
  };

  const handleEdit = (row) => {
    setSelected(row);
    setHsnSacName(row.HsnSacName);
    setOpen(true);
  };

  const handleAdd = () => {
    setSelected(null);
    setHsnSacName('');
    setOpen(true);
  };

  const handleSave = async () => {
    try {
      if (selected) {
        const token = localStorage.getItem("token");

const res = await axios.put(
  `${BASE_URL}/HsnSac/UpdateHsnSac/${selected.id}`,
  { HsnSacName: hsnSacName },
  {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
);
      } else {
        const token = localStorage.getItem("token");

const res = await axios.post(
  `${BASE_URL}/HsnSac/AddHsnSac`,
  { HsnSacName: hsnSacName },
  {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
);
      }
      setOpen(false);
      fetchData();
    } catch (err) {
      alert('Save failed');
    }
  };

  const columns = [
    { field: 'id', headerName: 'ID', flex: 1 },
    { field: 'HsnSacName', headerName: 'HSN/SAC Name', flex: 2 },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 1,
      sortable: false,
      renderCell: (params) => (
        <>
          <Button variant="outlined" color="primary" size="small" onClick={() => handleEdit(params.row)}>
            Edit
          </Button>
          <Button variant="outlined" color="error" size="small" onClick={() => handleDelete(params.row.id)} style={{ marginLeft: 8 }}>
            Delete
          </Button>
        </>
      )
    }
  ];

  return (
    <>
    <LayoutAdminHeader />
    <Box p={2}>
      <Typography variant="h5" gutterBottom>HSN/SAC List</Typography>
      <Box display="flex" justifyContent="space-between" mb={2}>
        <TextField label="Search" value={search} onChange={handleSearch} />
        <Button variant="contained" color="primary" onClick={handleAdd}>Add HSN/SAC</Button>
      </Box>
      <DataGrid
        autoHeight
        rows={filtered}
        columns={columns}
        pageSize={5}
        rowsPerPageOptions={[5, 10]}
        loading={loading}
        disableSelectionOnClick
        sortingOrder={['asc', 'desc']}
      />

      {/* Add/Edit Dialog */}
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>{selected ? 'Edit HSN/SAC' : 'Add HSN/SAC'}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="HSN/SAC Name"
            fullWidth
            value={hsnSacName}
            onChange={(e) => setHsnSacName(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleSave}>
            {selected ? 'Update' : 'Add'}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
      </>
  );
};

export default HsnSac;
